import { useState } from "react";
import { storage, db, auth } from "../../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { signInAnonymously } from "firebase/auth";
import DropFileInput from "../drop-file-input/DropFileInput";
import UploadButton from "../upload-button/UploadButton";

export default function VideoUpload({ profileData, onBack }) {
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (files) => setFile(files[0]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return alert("Please select a video!");

    setLoading(true);
    try {
      await signInAnonymously(auth);
      const fileRef = ref(storage, `videos_submissions/${file.name}`);
      const uploadTask = uploadBytesResumable(fileRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const prog = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setProgress(Math.trunc(prog));
        },
        (error) => {
          console.error("Upload failed:", error);
          alert("Video upload failed");
          setLoading(false);
        },
        async () => {
          const videoURL = await getDownloadURL(uploadTask.snapshot.ref);
          
          await addDoc(collection(db, "user-info"), {
            ...profileData,
            dob: new Date(profileData.dob),
            videoURL,
            submittedOn: serverTimestamp(),
          });

          alert("Form and video submitted successfully!");
          setFile(null);
          setProgress(0);
          setLoading(false);
        }
      );
    } catch (error) {
      console.error("Submission error:", error);
      alert("Failed to submit form");
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4 w-full max-w-md mx-auto p-4 rounded-lg shadow-md">
      <h1 className="text-xl font-bold text-center text-white">Upload Your Video</h1>

      <DropFileInput onFileChange={handleFileChange} />
      <button type="button" onClick={onBack} className="p-2 border rounded w-full">
        Back to Profile Info
      </button>
      <UploadButton>Upload</UploadButton>

      {loading && (
        <div className="w-full bg-gray-200 rounded-full h-4 mt-2">
          <div className="bg-blue-500 h-4 rounded-full transition-all" style={{ width: `${progress}%` }} />
        </div>
      )}

      
    </form>
  );
}
